import { Component } from '@angular/core';import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';
@Component({
  selector: 'app-assurance-prevoyance-deces',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-prevoyance-deces.component.html',
  styleUrls: ['./assurance-prevoyance-deces.component.scss']
})
export class AssurancePrevoyanceDecesComponent {
  title = 'Assurance Prévoyance Décès';
  subtitle = 'Protégez financièrement vos proches en cas de disparition';
  heroImage = 'assets/static_pages_images/prev-deces.jpg';
  
  breadcrumbs = [
    { label: 'Particuliers', link: undefined },
    { label: 'Assurance Prévoyance Décès', link: undefined }
  ];

  prevPage = { title: 'Prévoyance Obsèque',
    link: '/assurance-prevoyance-obseque'
  };

  nextPage = { title: 'Retraite Complémentaire Salarié',
    link: '/assurance-retraite-complementaire-salarie'
  };

  constructor(private router: Router) {}

  navigateToComparison(): void {
    this.router.navigate(['/cac/comparaison']);
  }

  navigateToDevis(): void {
    this.router.navigate(['/devis']);
  }
}

